import { createRouter, createWebHistory } from 'vue-router';
import HomeView from './components/HomeView.vue';
import AboutView from './components/AboutView.vue';
import SolutionsView from './components/SolutionsView.vue';
import SupportView from './components/SupportView.vue';
import ContactView from './components/ContactView.vue';

import AmethystView from './components/AmethystView.vue';
import IrecallView from './components/IrecallView.vue';
import TesView from './components/TesView.vue';
import TngView from './components/TngView.vue';

const routes = [
  { path: '/', component: HomeView },
  { path: '/about', component: AboutView },
  { path: '/solutions', component: SolutionsView },
  { path: '/support', component: SupportView },
  { path: '/contact', component: ContactView },
  
  { path: '/amethyst', component: AmethystView },
  { path: '/irecall', component: IrecallView },
  { path: '/tes', component: TesView },
  { path: '/tng', component: TngView }
];

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { top: 0 };
    }
  }
});

export default router;
